var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPulseSleep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10973_309628)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.664062 9.83464H2.66406L4.66406 5.16797L8.66406 14.5013L10.6641 9.83464H15.3307",
    stroke: "#680DDB",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3294 3.16706V1.90039C9.99604 2.23372 9.0627 3.63372 9.39604 5.10039C9.59604 6.03372 10.396 6.83372 11.3294 7.03372C12.8627 7.36706 14.196 6.43372 14.5294 5.10039H13.3294C12.196 5.16706 11.3294 4.30039 11.3294 3.16706Z",
    stroke: "#680DDB",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10973_309628"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulseSleep);
export default __webpack_public_path__ + "static/media/pulse_sleep.9417d1c519d82e4e8d5580f5fe7287e4.svg";
export { ForwardRef as ReactComponent };